import { FiTool } from "react-icons/fi";
import Collabse from "../../../components/Collabse";
import CancelBtn from "./CancelBtn";
import UploadBtn from "./UploadBtn";
import UrgentBtn from "./UrgentBtn";
import NoEmailsBtn from "./NoEmailsBtn";
import i18n from "i18next";
import { useAppSelector } from "../../../redux/store";

const LMXTools = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const isFrench = i18n.language === "fr";

  return (
    <div>
      <Collabse Header={Header}>
        <div className="grid 2xl: grid-cols-4 gap-4">
          {!isAgency && (
            <div className={`col-span-1 ${isFrench && "hidden"}`}>
              <UploadBtn />
            </div>
          )}

          <div className={`${isFrench ? "col-span-2" : "col-span-1"}`}>
            <CancelBtn />
          </div>

          <div className={`col-span-1 ${isFrench && "hidden"}`}>
            <UrgentBtn />
          </div>

          <div className={`col-span-1 ${isFrench && "hidden"}`}>
            <NoEmailsBtn />
          </div>
        </div>
      </Collabse>
    </div>
  );
};

const Header = () => {
  return (
    <h5>
      <FiTool />
      LMX Tools
    </h5>
  );
};

export default LMXTools;
